import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'

export default function TimePickerBox({ value, showLabel, onChange, checked = false }) {
  const [selected, setSelected] = useState(checked)

  const onClick = () => {
    onChange(val)
    setSelected(!selected)
  }

  const bg = selected ? 'colorActivePrimary' : 'colorFillEmphasis'
  const borderStyle = selected ? 'solid' : 'dashed'

  const name = `hour${value}`

  const val = `${value}:00`

  return (
    <Box
      as="label"
      display="inline-block"
      marginBottom="spaceGapXLarge"
      cursor="pointer"
      alignItems="center"
      htmlFor={name}
      backgroundColor={bg}
      height="22px"
      width="17px"
      marginRight="2px"
      onClick={onClick}
      borderWidth="1px"
      borderStyle={borderStyle}
      borderColor="colorBorderEmphasis"
      position="relative"
      _hover={{
        backgroundColor: 'colorActionPrimaryHover',
        cursor: 'pointer',
        _before: {
          content: `'${val}'`,
        },
        _after: {
          content: "''",
        },
      }}
      _before={{
        color: 'colorTextEmphasis',
        backgroundColor: 'colorFillMain',
        position: 'absolute',
        top: '-40px',
        left: '50%',
        padding: '8px',
        lineHeight: 1,
        borderRadius: '4px',
        transform: 'translate(-50%, 0)',
      }}
      _after={{
        width: 0,
        height: 0,
        position: 'absolute',
        border: '7px solid transparent',
        borderTop: '7px solid',
        borderRight: '7px solid',
        margin: '15px',
        transform: 'rotate(135deg) translate(200%, 15%)',
        color: 'colorFillMain',
        top: '-55px',
      }}
    >
      <Box as="input" type="checkbox" name={name} value={val} checked={selected} opacity={0} width="0px" height="0px" onChange={() => {}}/>
      {showLabel && (
        <Box as="span" fontSize="8px" display="inline-block" transform="translate(-10%, 5px)">
          {val}
        </Box>
      )}
    </Box>
  )
}

TimePickerBox.propTypes = {
  value: PropTypes.string,
  showLabel: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
}
